import React, { useContext, useEffect } from "react";
import { Route, Router, Switch } from "react-router";
import { SemanticToastContainer, toast } from "react-semantic-toasts";
import "react-semantic-toasts/styles/react-semantic-alert.css";
import Footer from "./components/Footer";
import ResponsiveNavbar from "./components/ResponsiveNavbar";
import Home from "./pages/Home";
import SignIn from "./pages/SignIn";
import SignOut from "./pages/SignOut";
import SilentRenew from "./pages/Silent";
import ThankYou from "./pages/ThankYou";
import { signInRedirect } from "./services/UserService";
import { PortalType, State } from "./State";
import { Action, store } from "./store";
import ReactGA from 'react-ga';


function renderUnderwriting(state: State, dispatch: React.Dispatch<Action>, inquiryType: number): JSX.Element {
    if (state.appState.optionChosen !== PortalType.Underwriting) {
        dispatch({ type: "set underwriting", value: inquiryType });
    }
    return <Home />;
}

function renderSingleEntity(state: State, dispatch: React.Dispatch<Action>): JSX.Element {
    if (state.appState.optionChosen !== PortalType.SingleEntityOwnership) {
        dispatch({ type: "set ownership" });
    }
    return <Home />;
}

function renderPolicyCoverage(state: State, dispatch: React.Dispatch<Action>): JSX.Element {
    if (state.appState.optionChosen !== PortalType.PolicyCoverage) {
        dispatch({ type: "set policyCoverage" });
    }
    return <Home />;
}

function renderExperienceRating(state: State, dispatch: React.Dispatch<Action>): JSX.Element {
    if (state.appState.optionChosen !== PortalType.ExperienceRating) {
        dispatch({ type: "set experienceRating" });
    }
    return <Home />;
}

function renderNoticeOfElection(state: State, dispatch: React.Dispatch<Action>): JSX.Element {
    if (state.appState.optionChosen !== PortalType.NoticeOfElection) {
        dispatch({ type: "set noticeOfElection" });
    }
    return <Home />;
}

function renderPlan(state: State, dispatch: React.Dispatch<Action>): JSX.Element {
    if (state.appState.optionChosen !== PortalType.Plan) {
        dispatch({ type: "set plan" });
        dispatch({ type: "check authentication" });
    }
    return <Home />;
}

function renderActuarial(state: State, dispatch: React.Dispatch<Action>): JSX.Element {
    if (state.appState.optionChosen !== PortalType.Actuarial) {
        dispatch({ type: "set actuarial" });
    }
    return <Home />;
}

function renderMembership(state: State, dispatch: React.Dispatch<Action>): JSX.Element {
    if (state.appState.optionChosen !== PortalType.Membership) {
        dispatch({ type: "set membership" });
    }
    return <Home />;
}

function renderSpecialCalls(state: State, dispatch: React.Dispatch<Action>): any {
    if (state.appState.optionChosen !== PortalType.SpecialCalls) {
        dispatch({ type: "set specialCalls" });
        dispatch({ type: "check authentication" });
    }
    return <Home />;
}


const App: React.FC = () => {
    const globalState = useContext(store);
    const { dispatch } = globalState;
    const trackingId = 'UA-9077260-7';
    ReactGA.initialize(trackingId);
    globalState.state.appState.history.listen(location => {
        ReactGA.set({ page: location.pathname });
        ReactGA.pageview(location.pathname);
    })

    return (
      // tslint:disable-next-line: max-line-length
      <div className="App" style={{ backgroundColor: globalState.state.appState.isDarkTheme ? "#282c34" : "whitesmoke" }}>
          <div className="App-header" style={{ backgroundColor: globalState.state.appState.isDarkTheme ? "#282c34" : "whitesmoke" }}>
              <Router history={globalState.state.appState.history}>
                  <ResponsiveNavbar>
                      <Switch>
                          <Route exact path="/"                   render={() => <Home />}  />
                          <Route exact path="/audit-inquiry"      render={() => renderUnderwriting(globalState.state, dispatch, 0)} />
                          <Route exact path="/class-inquiry"      render={() => renderUnderwriting(globalState.state, dispatch, 1)} />
                          <Route exact path="/single-entity"      render={() => renderSingleEntity(globalState.state, dispatch)} />
                          <Route exact path="/policy-coverage"    render={() => renderPolicyCoverage(globalState.state, dispatch)} />
                          <Route exact path="/experience-rating"  render={() => renderExperienceRating(globalState.state, dispatch)} />
                          <Route exact path="/notice-of-election" render={() => renderNoticeOfElection(globalState.state, dispatch)} />
                          <Route exact path="/plan"               render={() => renderPlan(globalState.state, dispatch)} />
                          <Route exact path="/special-calls"      render={() => renderSpecialCalls(globalState.state, dispatch)} />
                          <Route exact path="/actuarial"          render={() => renderActuarial(globalState.state, dispatch)} />
                          <Route exact path="/membership"         render={() => renderMembership(globalState.state, dispatch)} />
                          <Route exact path="/ThankYou"           render={() => <ThankYou />} />
                          <Route path="/signin-oidc" component={SignIn} />
                          <Route path="/signout-oidc" component={SignOut} />
                          <Route path="/silent" component={SilentRenew} />
                      </Switch>
                      <SemanticToastContainer position={"bottom-right"} animation={"bounce"} className={"error-toast"}  />
                  </ResponsiveNavbar>
              </Router>
          </div>
          <Footer />
      </div>
  );
};

export default App;
